var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spinner_svg__a)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2000,
    height: 2000,
    x: -1000,
    y: -1000,
    transform: "translate(30 30)scale(.025)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(58,142,246,0) 0deg,#3a8ef6 359.964deg,rgba(58,142,246,0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 30c0 13.807-11.193 25-25 25S5 43.807 5 30 16.193 5 30 5s25 11.193 25 25m-41.25 0c0 8.975 7.275 16.25 16.25 16.25S46.25 38.975 46.25 30 38.975 13.75 30 13.75 13.75 21.025 13.75 30",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.99989998340606689},{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.99989998340606689},{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":49.999996185302734,\"m01\":0.0,\"m02\":5.0,\"m10\":0.0,\"m11\":49.999996185302734,\"m12\":5.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spinner_svg__b)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2000,
    height: 2000,
    x: -1000,
    y: -1000,
    transform: "rotate(-90 30 0)scale(.025)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(58,142,246,0) 0deg,#3a8ef6 359.964deg,rgba(58,142,246,0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5a25 25 0 0 1 25 25h-8.75A16.25 16.25 0 0 0 30 13.75z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.99989998340606689},{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.99989998340606689},{\"color\":{\"r\":0.22745098173618317,\"g\":0.55686277151107788,\"b\":0.96470588445663452,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":-2.1855692011740757e-06,\"m01\":49.999996185302734,\"m02\":5.0,\"m10\":-49.999996185302734,\"m11\":-2.1855692011740757e-06,\"m12\":55.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spinner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 30c0 13.807-11.193 25-25 25S5 43.807 5 30 16.193 5 30 5s25 11.193 25 25m-41.25 0c0 8.975 7.275 16.25 16.25 16.25S46.25 38.975 46.25 30 38.975 13.75 30 13.75 13.75 21.025 13.75 30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "spinner_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 5a25 25 0 0 1 25 25h-8.75A16.25 16.25 0 0 0 30 13.75z"
  })))));
};
export default SvgSpinner;